"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var __1 = require("../..");
var transifex_1 = require("../../../transifex");
var imageTypes = ["image/jpeg", "image/jpg", "image/png"];
var UploadMultipleWithButton = function (_a) {
    var fileList = _a.fileList, onRemove = _a.onRemove, onChange = _a.onChange, style = _a.style, className = _a.className, disabled = _a.disabled, props = __rest(_a, ["fileList", "onRemove", "onChange", "style", "className", "disabled"]);
    var imageFileList = fileList === null || fileList === void 0 ? void 0 : fileList.filter(function (file) { var _a; return imageTypes.includes((_a = file.type) !== null && _a !== void 0 ? _a : ""); });
    var otherFileList = fileList === null || fileList === void 0 ? void 0 : fileList.filter(function (file) { var _a; return !imageTypes.includes((_a = file.type) !== null && _a !== void 0 ? _a : ""); });
    return (react_1.default.createElement(antd_1.Row, { className: className, style: __assign({ width: "100%" }, style) },
        react_1.default.createElement(antd_1.Col, { xs: 24 },
            react_1.default.createElement(antd_1.Row, { style: { width: "100%", marginBottom: "0.5rem" }, align: "middle", justify: "space-between" },
                react_1.default.createElement(antd_1.Col, null,
                    react_1.default.createElement(__1.Typography, null, transifex_1.TX_ATTACHMENTS)),
                react_1.default.createElement(antd_1.Col, null,
                    react_1.default.createElement(antd_1.Upload, __assign({ showUploadList: false, style: { width: "100%" }, accept: ".png,.jpg,.jpeg,.pdf,.docx,.doc", fileList: fileList, onRemove: onRemove, onChange: onChange, disabled: disabled }, props),
                        react_1.default.createElement(antd_1.Button, { disabled: disabled, htmlType: "button", type: "ghost", icon: react_1.default.createElement(icons_1.UploadOutlined, { style: { marginRight: 10 } }) }, transifex_1.TX_UPLOAD))))),
        react_1.default.createElement(antd_1.Col, { style: {
                display: (imageFileList === null || imageFileList === void 0 ? void 0 : imageFileList.length) === 0 ? "none" : "inline-block",
                // to prevent a ui bug where upload has a height with no data
            }, xs: 24 },
            react_1.default.createElement(antd_1.Upload, { onRemove: onRemove, onChange: function (_a) {
                    var _b;
                    var file = _a.file;
                    return onChange === null || onChange === void 0 ? void 0 : onChange({
                        file: file,
                        fileList: (_b = fileList === null || fileList === void 0 ? void 0 : fileList.filter(function (f) { return f.uid !== file.uid; })) !== null && _b !== void 0 ? _b : [],
                    });
                }, listType: "picture-card", fileList: imageFileList, disabled: disabled })),
        react_1.default.createElement(antd_1.Col, { style: {
                display: (otherFileList === null || otherFileList === void 0 ? void 0 : otherFileList.length) === 0 ? "none" : "inline-block",
            }, xs: 24 },
            react_1.default.createElement(antd_1.Upload, { onRemove: onRemove, onChange: function (_a) {
                    var _b;
                    var file = _a.file;
                    return onChange === null || onChange === void 0 ? void 0 : onChange({
                        file: file,
                        fileList: (_b = fileList === null || fileList === void 0 ? void 0 : fileList.filter(function (f) { return f.uid !== file.uid; })) !== null && _b !== void 0 ? _b : [],
                    });
                }, listType: "text", fileList: otherFileList, disabled: disabled }))));
};
exports.default = UploadMultipleWithButton;
